export enum TcListDefaultAction {
  Delete = 'delete',
  Duplicate = 'duplicate',
}
